import { computed, inject, Injectable } from '@angular/core';
import { patientActions, selectTeeth, selectTeethLoading } from '@libs/store';
import { Store } from '@ngrx/store';
import { PerioHistory } from '@libs/ui-lib';

export interface PerioViewModel {
  perioExams: PerioHistory[];
  loading: boolean;
}

@Injectable()
export class PerioScreenComponentService {
  private readonly store = inject(Store);

  public init(siteId?: string, patientId?: string, forcePerioExamRefetch = false): void {
    if (!siteId || !patientId) return;

    if (forcePerioExamRefetch) {
      this.store.dispatch(patientActions.onLoadTeeth({ siteId, patientId, examCount: 5, silentReload: false }));
    }
  }

  public viewModel = computed<PerioViewModel>(() => {
    const loading = this.store.selectSignal(selectTeethLoading)();
    const teethData = this.store.selectSignal(selectTeeth)();
    const perioExamsWithTeeth = [...(teethData?.perioExamsWithTeeth || [])];

    return {
      perioExams:
        perioExamsWithTeeth.map((exam) => ({
          date: exam.date,
          teeth: exam.teeth,
          provisionalStatus: exam.provisionalStatus,
        })) ?? [],
      loading: loading,
    };
  });
}
